/* eslint-disable max-len , quote-props */
import { INTL_IDS } from './messages';

export const AMORTIZE_CALCULATE = 'app/Calculators/Amortize/AMORTIZE_CALCULATE';
export const AMORTIZE_CALCULATE_FAILURE = 'app/Calculators/Amortize/AMORTIZE_CALCULATE_FAILURE';
export const AMORTIZE_CALCULATE_SUCCESS = 'app/Calculators/Amortize/AMORTIZE_CALCULATE_SUCCESS';

export const AMORTIZE_STATUS = 'app/Calculators/Amortize/AMORTIZE_STATUS';
export const AMORTIZE_STATUS_FAILURE = 'app/Calculators/Amortize/AMORTIZE_STATUS_FAILURE';
export const AMORTIZE_STATUS_SUCCESS = 'app/Calculators/Amortize/AMORTIZE_STATUS_SUCCESS';

export const CHANGE_ADJUSTMENT_FILTER = 'app/Calculators/Amortize/CHANGE_ADJUSTMENT_FILTER';

export const CHANGE_INPUT = 'app/Calculators/Amortize/CHANGE_INPUT';

export const CHANGE_STEP = 'app/Calculators/Amortize/CHANGE_STEP';

export const RESET_ALL_CALCULATORS = 'app/Calculators/Amortize/RESET_ALL_CALCULATORS';
export const RESET_CALCULATOR = 'app/Calculators/Amortize/RESET_CALCULATOR';
export const RESET_CALCULATOR_RESULTS = 'app/Calculators/Amortize/RESET_CALCULATOR_RESULTS';

export const RESET_FORM_ERROR = 'app/Calculators/Amortize/RESET_FORM_ERROR';

export const RESET_STATE = 'app/Calculators/Amortize/RESET_STATE';

export const RESET_STATUS = 'app/Calculators/Amortize/RESET_STATUS';

export const RESET_STEP = 'app/Calculators/Amortize/RESET_STEP';

export const SET_IS_SCHEDULE_DRAWER_OPEN = 'app/Calculators/Amortize/SET_IS_SCHEDULE_DRAWER_OPEN';
export const SET_IS_SLIDER_FOCUSED = 'app/Calculators/Amortize/SET_IS_SLIDER_FOCUSED';

export const UPDATE_FORM_ERROR = 'app/Calculators/Amortize/UPDATE_FORM_ERROR';

// Messages
export const AMORTIZE_DEFAULT_ERROR_MESSAGE = 'Error loading, please refresh the page.';
export const AMORTIZE_UNAVAILABLE_ERROR_MESSAGE = 'Sorry!\nThis feature is unavailable';

// Form Validation Messages
export const DECIMAL_ERROR = 'Amount can only have two digits after decimal point.';
export const INTEREST_RATE_ERROR = 'Interest rate can only have three digits after decimal point.';
export const PAYMENT_LIMIT_ERROR = 'Amount should be less than or equal to loan amount.';
export const VALUE_ERROR = 'Must be greater than zero.';

// In Calculator page tab order
export const ADJUSTMENT_FILTER_DICTIONARY = {
  amortization: {
    calendarSubText: 'Selected Start Date',
    filterLabel: 'Amortization',
  },
  payMoreMonthly: {
    calendarSubText: 'Selected Start Date',
    errorText: 'Additional Payment',
    filterLabel: 'Pay More Monthly',
    headerText: 'Add Additional Monthly Payment',
  },
  // eslint-disable-next-line sort-keys
  payLumpSum: {
    calendarSubText: 'Selected Date',
    errorText: 'Lump Sum',
    filterLabel: 'Pay Lump Sum',
    headerText: 'One-Time Lump Sum Payment',
  },
};

export const PROCEED_DICTIONARY = {
  payLumpSum: {
    fieldLabels: [],
    header: 'Make a lump sum payment of {{amount}}.',
  },
  payMoreMonthly: {
    fieldLabels: [
      { key: 'updatedMonthlyPayment', label: 'Updated Monthly Payment' },
    ],
    header: 'Update Autopay with an additional monthly payment of {{amount}}.',
  },
};

export const PROCEED_DICTIONARY_AUTOPAY_SETUP = {
  payMoreMonthly: {
    fieldLabels: [],
    header: 'Update autopay with an additional monthly payment of {{amount}}.',
  },
};

export const RESULTS_DICTIONARY = {
  payLumpSum: {
    cardsHeader: 'If you make a lump sum payment of {{amount}}',
    cardsLabels: [
      { key: 'payoffDate', label: 'Payoff Date' },
      { key: 'loanTerm', label: 'Shorten the Loan by' },
      { key: 'interestSavings', label: 'Interest Savings' },
    ],
    navigationHeader: 'Pay a Lump Sum Results',
  },
  payMoreMonthly: {
    cardsHeader: 'If you add {{amount}} to your monthly payment',
    cardsLabels: [
      { key: 'payoffDate', label: 'Payoff Date' },
      { key: 'loanTerm', label: 'Shorten the Loan by' },
      { key: 'interestSavings', label: 'Interest Savings' },
    ],
    navigationHeader: 'Pay More Monthly Results',
  },
};

export const NO_RESULTS_DICTIONARY = {
  header: 'We are unable to calculate your results right now',
  paragraph: 'Please try again later.',
};

export const REASON_CODE_DICTIONARY = {
  '13001.1000': {
    key: 'serviceError',
    message: 'Current Principal balance is zero.',
  },
  '13001.1001': {
    key: 'serviceError',
    message: 'Current Annual interest rate is not available.',
  },
  '13001.1002': {
    key: 'serviceError',
    message: 'Current Monthly payment amount is not available.',
  },
  '13001.2000': {
    key: 'startDate',
    message: '{{selectedAdjustment}} date is invalid.',
  },
  '13001.2001': {
    key: 'amount',
    message: '{{selectedAdjustment}} amount is invalid.',
  },
  '13001.2002': {
    key: 'amount',
    message: '{{selectedAdjustment}} amount can only have two digits after decimal point.',
  },
  '13001.2003': {
    key: 'serviceError',
    message: 'Sorry, something unexpected happened. Please try again.',
  },
  '13001.2004': {
    key: 'numberOfPayments',
    message: 'Number of Payments is invalid.',
  },
  '13001.2005': {
    key: 'principalBalance',
    message: 'Loan amount is invalid.',
  },
  '13001.2006': {
    key: 'principalBalance',
    message: 'Loan amount can only have two digits after decimal point.',
  },
  '13001.2007': {
    key: 'interestRate',
    message: 'Interest rate is invalid.',
  },
  '13001.2008': {
    key: 'interestRate',
    message: 'Interest rate can only have three digits after decimal point.',
  },
  '13001.2009': {
    key: 'monthlyPaymentAmount',
    message: 'Monthly payment amount should be greater than or equal to minimum payment amount.',
  },
  '13001.2010': {
    key: 'monthlyPaymentAmount',
    message: 'Monthly payment amount should be less than loan amount.',
  },
  '13001.2011': {
    key: 'monthlyPaymentAmount',
    message: 'Monthly Payment amount can only have two digits after decimal point.',
  },
  'validationError': 'Amortization calculation request is invalid',
};

export const TOOLTIP_DICTIONARY = {
  amortization: {
    headingText: 'Calculated Amortization Schedule',
    linkText: 'Got it',
    paragraphs: [
      INTL_IDS.TOOLTIP_AMORTIZATION_TEXT_1,
      INTL_IDS.TOOLTIP_AMORTIZATION_TEXT_2,
    ],
  },
  payLumpSum: {
    headingText: 'How to use this calculator',
    linkText: 'Got it',
    paragraphs: [
      INTL_IDS.TOOLTIP_PAYLUMPSUM_TEXT_1,
    ],
  },
  payMoreMonthly: {
    headingText: 'How to use this calculator',
    linkText: 'Got it',
    paragraphs: [
      INTL_IDS.TOOLTIP_PAYMOREMONTHLY_TEXT_1,
    ],
  },
};

export const AMORTIZATION_CHART_DESCRIPTION = 'showing balance, cumulative interest and cumulative principle by months';

export const AMORTIZATION_TYPES_DICT = {
  Annually: 'Yearly',
  Monthly: 'Monthly',
  'Monthly Payment Amount': 'Monthly_Payment_Amount',
  Monthly_Payment_Amount: 'Monthly Payment Amount',
  'Number of Months': 'Number_Of_Months',
  Number_Of_Months: 'Number of Months',
  'One Time': 'One_Time',
  One_Time: 'One Time',
  Yearly: 'Annually',
};

export const AMORTIZATION_SCHEDULE_COLUMNS = [
  {
    intlId: INTL_IDS.SCHEDULETABLE_COLUMN_PAYMENTNUMBER,
    value: 'paymentNumber',
  },
  {
    intlId: INTL_IDS.SCHEDULETABLE_COLUMN_PAYMENTDATE,
    value: 'paymentDate',
  },
  {
    intlId: INTL_IDS.SCHEDULETABLE_COLUMN_STARTINGBALANCE,
    value: 'startingBalance',
  },
  {
    intlId: INTL_IDS.SCHEDULETABLE_COLUMN_PRINCIPALPAYMENT,
    value: 'principalPayment',
  },
  {
    intlId: INTL_IDS.SCHEDULETABLE_COLUMN_INTERESTPAYMENT,
    value: 'interestPayment',
  },
  {
    intlId: INTL_IDS.SCHEDULETABLE_COLUMN_CUMULATIVEPRINCIPAL,
    value: 'cumulativePrincipal',
  },
  {
    intlId: INTL_IDS.SCHEDULETABLE_COLUMN_CUMULATIVEINTEREST,
    value: 'cumulativeInterest',
  },
  {
    intlId: INTL_IDS.SCHEDULETABLE_COLUMN_ENDINGBALANCE,
    value: 'endingBalance',
  },
];

export const SCHEDULE_HEADERS = [
  'paymentNumber',
  'paymentDate',
  'startingBalance',
  'principalPayment',
  'interestPayment',
  'cumulativePrincipal',
  'cumulativeInterest',
  'endingBalance',
];

const desktopBalanceLine = 'success';
const desktopInterestLine = 'error';
const desktopPrincipalLine = 'primary';
const mobileBalanceLine = 'accentGreen';
const mobileInterestLine = 'accentRed';
const mobilePrincipalLine = 'primary';

export const SCHEDULE_CHART_LINES = [
  {
    coordinates: { x: 'paymentNumber', y: 'startingBalanceAmount' },
    desktopCalculatedName: INTL_IDS.SCHEDULECHART_DESKTOPCALCULATEDNAME_BALANCE,
    desktopLineColor: desktopBalanceLine,
    mobileCalculatedName: INTL_IDS.SCHEDULECHART_MOBILECALCULATEDNAME_BALANCE,
    mobileLineColor: mobileBalanceLine,
    name: INTL_IDS.SCHEDULECHART_NAME_BALANCE,
  },
  {
    coordinates: { x: 'paymentNumber', y: 'cumulativeInterestAmount' },
    desktopCalculatedName: INTL_IDS.SCHEDULECHART_DESKTOPCALCULATEDNAME_INTEREST,
    desktopLineColor: desktopInterestLine,
    mobileCalculatedName: INTL_IDS.SCHEDULECHART_MOBILECALCULATEDNAME_INTEREST,
    mobileLineColor: mobileInterestLine,
    name: INTL_IDS.SCHEDULECHART_NAME_INTEREST,
  },
  {
    coordinates: { x: 'paymentNumber', y: 'cumulativePrincipalAmount' },
    desktopCalculatedName: INTL_IDS.SCHEDULECHART_DESKTOPCALCULATEDNAME_PRINCIPAL,
    desktopLineColor: desktopPrincipalLine,
    mobileCalculatedName: INTL_IDS.SCHEDULECHART_MOBILECALCULATEDNAME_PRINCIPAL,
    mobileLineColor: mobilePrincipalLine,
    name: INTL_IDS.SCHEDULECHART_NAME_PRINCIPAL,
  },
];

export const SLIDER_LABELS = {
  lumpSum: [
    { label: 0, value: 0 },
    { label: '$1k', value: 1000 },
    { label: '$2k', value: 2000 },
    { label: '$3k', value: 3000 },
    { label: '$4k', value: 4000 },
    { label: '$5k', value: 5000 },
    { label: '$6k', value: 6000 },
  ],
  payMoreMonthly: [
    { label: 0, value: 0 },
    { label: '$50', value: 50 },
    { label: '$100', value: 100 },
    { label: '$150', value: 150 },
    { label: '$200', value: 200 },
    { label: '$250', value: 250 },
    { label: '$300', value: 300 },
  ],
};
